module.exports = __webpack_public_path__ + "img/jfxx.8a76bab2.png";